export default "__VITE_ASSET__BUFGanbD__"